import { render, staticRenderFns } from "./IllegalCutting.vue?vue&type=template&id=75949670&scoped=true&"
import script from "./IllegalCutting.vue?vue&type=script&lang=js&"
export * from "./IllegalCutting.vue?vue&type=script&lang=js&"
import style0 from "./IllegalCutting.vue?vue&type=style&index=0&id=75949670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75949670",
  null
  
)

export default component.exports